import { Injectable, inject } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { IApplication, IJobOffer } from '../../../../../assets/types/dtoTypes';

@Injectable( {
  providedIn: 'root',
} )
export class ApplicationsOverviewPageService {
  private readonly http = inject(HttpClient);
  private readonly applicationsUrl = `${environment.apiUrl}/job-applications`;
  private readonly jobOffersUrl = `${environment.apiUrl}/job-offers`;
  private readonly usersUrl = `${environment.apiUrl}/users`;

  constructor() {}

  getAllApplicationsByUserId( userId: string ): Observable<IApplication[]> {
    const url = `${this.applicationsUrl}/user/${userId}`;
    return this.http.get<IApplication[]>( url );
  }

  getJobOfferById( jobOfferId: string ): Observable<IJobOffer> {
    const url = `${this.jobOffersUrl}/${jobOfferId}`;
    return this.http.get<IJobOffer>( url );
  }

  withdraw( id: string ): Observable<string> {
    const url = `${this.applicationsUrl}/${id}/status`;
    return this.http.put<string>( url, { status: 'REJECTED' } );
  }

  accept( id: string ): Observable<string> {
    const url = `${this.applicationsUrl}/${id}/status`;
    return this.http.put<string>( url, { status: 'ACCEPTED' } );
  }

  deleteUser( userId: string ): Observable<void> {
    const url = `${this.usersUrl}/${userId}`;
    return this.http.delete<void>( url );
  }
}
